/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createDefaultVipDiscounts } from '../fn/vip-discounts/create-default-vip-discounts';
import { CreateDefaultVipDiscounts$Params } from '../fn/vip-discounts/create-default-vip-discounts';
import { createVipDiscount } from '../fn/vip-discounts/create-vip-discount';
import { CreateVipDiscount$Params } from '../fn/vip-discounts/create-vip-discount';
import { DefaultVipDiscountResponseModel } from '../models/default-vip-discount-response-model';
import { deleteDefaultVipDiscount } from '../fn/vip-discounts/delete-default-vip-discount';
import { DeleteDefaultVipDiscount$Params } from '../fn/vip-discounts/delete-default-vip-discount';
import { ExistingVipDiscountsResponse } from '../models/existing-vip-discounts-response';
import { findExistingVipDiscountCombinations } from '../fn/vip-discounts/find-existing-vip-discount-combinations';
import { FindExistingVipDiscountCombinations$Params } from '../fn/vip-discounts/find-existing-vip-discount-combinations';
import { getDefaultVipDiscount } from '../fn/vip-discounts/get-default-vip-discount';
import { GetDefaultVipDiscount$Params } from '../fn/vip-discounts/get-default-vip-discount';
import { getGivenVipDiscountCompanies } from '../fn/vip-discounts/get-given-vip-discount-companies';
import { GetGivenVipDiscountCompanies$Params } from '../fn/vip-discounts/get-given-vip-discount-companies';
import { getGivenVipDiscountLists } from '../fn/vip-discounts/get-given-vip-discount-lists';
import { GetGivenVipDiscountLists$Params } from '../fn/vip-discounts/get-given-vip-discount-lists';
import { getReceivedVipDiscountsByCompany } from '../fn/vip-discounts/get-received-vip-discounts-by-company';
import { GetReceivedVipDiscountsByCompany$Params } from '../fn/vip-discounts/get-received-vip-discounts-by-company';
import { getReceivedVipDiscountsByDrinkType } from '../fn/vip-discounts/get-received-vip-discounts-by-drink-type';
import { GetReceivedVipDiscountsByDrinkType$Params } from '../fn/vip-discounts/get-received-vip-discounts-by-drink-type';
import { listDefaultVipDiscounts } from '../fn/vip-discounts/list-default-vip-discounts';
import { ListDefaultVipDiscounts$Params } from '../fn/vip-discounts/list-default-vip-discounts';
import { PagedModelDefaultVipDiscountResponseModel } from '../models/paged-model-default-vip-discount-response-model';
import { PagedModelVipDiscountDto } from '../models/paged-model-vip-discount-dto';
import { searchGivenVipDiscounts } from '../fn/vip-discounts/search-given-vip-discounts';
import { SearchGivenVipDiscounts$Params } from '../fn/vip-discounts/search-given-vip-discounts';
import { triggerDefaultVipDiscount } from '../fn/vip-discounts/trigger-default-vip-discount';
import { TriggerDefaultVipDiscount$Params } from '../fn/vip-discounts/trigger-default-vip-discount';
import { triggerDefaultVipDiscounts } from '../fn/vip-discounts/trigger-default-vip-discounts';
import { TriggerDefaultVipDiscounts$Params } from '../fn/vip-discounts/trigger-default-vip-discounts';
import { updateDefaultVipDiscount } from '../fn/vip-discounts/update-default-vip-discount';
import { UpdateDefaultVipDiscount$Params } from '../fn/vip-discounts/update-default-vip-discount';
import { updateVipDiscount } from '../fn/vip-discounts/update-vip-discount';
import { UpdateVipDiscount$Params } from '../fn/vip-discounts/update-vip-discount';
import { VipDiscountCompanyDto } from '../models/vip-discount-company-dto';
import { VipDiscountCreateResponse } from '../models/vip-discount-create-response';
import { VipDiscountDto } from '../models/vip-discount-dto';
import { VipDiscountListByCompanyResponse } from '../models/vip-discount-list-by-company-response';
import { VipDiscountListByTypeResponse } from '../models/vip-discount-list-by-type-response';


/**
 * VIP discount management endpoints. Most operations require PRODUCT_ADMIN. /defaults operations (CRUD, trigger) require EASYLOT_ADMIN or PRODUCT_ADMIN.
 */
@Injectable({ providedIn: 'root' })
export class VipDiscountsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateVipDiscount()` */
  static readonly UpdateVipDiscountPath = '/discounts/vip/{vipDiscountId}';

  /**
   * Updates specified VIP discount.
   *
   * Updates an existing VIP discount based on its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateVipDiscount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVipDiscount$Response(params: UpdateVipDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateVipDiscount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates specified VIP discount.
   *
   * Updates an existing VIP discount based on its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateVipDiscount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVipDiscount(params: UpdateVipDiscount$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateVipDiscount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getDefaultVipDiscount()` */
  static readonly GetDefaultVipDiscountPath = '/discounts/vip/defaults/{defaultVipDiscountId}';

  /**
   * Get a default VIP discount.
   *
   * Gets the specified default VIP discount
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDefaultVipDiscount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultVipDiscount$Response(params: GetDefaultVipDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<DefaultVipDiscountResponseModel>> {
    const obs = getDefaultVipDiscount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a default VIP discount.
   *
   * Gets the specified default VIP discount
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDefaultVipDiscount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultVipDiscount(params: GetDefaultVipDiscount$Params, context?: HttpContext): Observable<DefaultVipDiscountResponseModel> {
    const resp = this.getDefaultVipDiscount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DefaultVipDiscountResponseModel>): DefaultVipDiscountResponseModel => r.body)
    );
  }

  /** Path part for operation `updateDefaultVipDiscount()` */
  static readonly UpdateDefaultVipDiscountPath = '/discounts/vip/defaults/{defaultVipDiscountId}';

  /**
   * Update a default VIP discount.
   *
   * Updates the specified default VIP discount
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDefaultVipDiscount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDefaultVipDiscount$Response(params: UpdateDefaultVipDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<DefaultVipDiscountResponseModel>> {
    const obs = updateDefaultVipDiscount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a default VIP discount.
   *
   * Updates the specified default VIP discount
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDefaultVipDiscount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDefaultVipDiscount(params: UpdateDefaultVipDiscount$Params, context?: HttpContext): Observable<DefaultVipDiscountResponseModel> {
    const resp = this.updateDefaultVipDiscount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DefaultVipDiscountResponseModel>): DefaultVipDiscountResponseModel => r.body)
    );
  }

  /** Path part for operation `deleteDefaultVipDiscount()` */
  static readonly DeleteDefaultVipDiscountPath = '/discounts/vip/defaults/{defaultVipDiscountId}';

  /**
   * Delete a default VIP discount.
   *
   * Deletes the specified default VIP discount
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDefaultVipDiscount()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDefaultVipDiscount$Response(params: DeleteDefaultVipDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteDefaultVipDiscount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a default VIP discount.
   *
   * Deletes the specified default VIP discount
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDefaultVipDiscount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDefaultVipDiscount(params: DeleteDefaultVipDiscount$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteDefaultVipDiscount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createVipDiscount()` */
  static readonly CreateVipDiscountPath = '/discounts/vip';

  /**
   * Creates a new VIP discount entry.
   *
   * Creates a new VIP discount and returns the saved resource identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createVipDiscount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVipDiscount$Response(params: CreateVipDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<VipDiscountCreateResponse>> {
    const obs = createVipDiscount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new VIP discount entry.
   *
   * Creates a new VIP discount and returns the saved resource identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createVipDiscount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVipDiscount(params: CreateVipDiscount$Params, context?: HttpContext): Observable<VipDiscountCreateResponse> {
    const resp = this.createVipDiscount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VipDiscountCreateResponse>): VipDiscountCreateResponse => r.body)
    );
  }

  /** Path part for operation `findExistingVipDiscountCombinations()` */
  static readonly FindExistingVipDiscountCombinationsPath = '/discounts/vip/existing-combinations';

  /**
   * Get already existing VIP discounts by merchant and product.
   *
   * Finds and returns already existing VIP discounts by merchant and product. Requires PRODUCT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findExistingVipDiscountCombinations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findExistingVipDiscountCombinations$Response(params: FindExistingVipDiscountCombinations$Params, context?: HttpContext): Observable<StrictHttpResponse<ExistingVipDiscountsResponse>> {
    const obs = findExistingVipDiscountCombinations(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get already existing VIP discounts by merchant and product.
   *
   * Finds and returns already existing VIP discounts by merchant and product. Requires PRODUCT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findExistingVipDiscountCombinations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findExistingVipDiscountCombinations(params: FindExistingVipDiscountCombinations$Params, context?: HttpContext): Observable<ExistingVipDiscountsResponse> {
    const resp = this.findExistingVipDiscountCombinations$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ExistingVipDiscountsResponse>): ExistingVipDiscountsResponse => r.body)
    );
  }

  /** Path part for operation `listDefaultVipDiscounts()` */
  static readonly ListDefaultVipDiscountsPath = '/discounts/vip/defaults';

  /**
   * Listing default VIP discounts.
   *
   * Lists available default VIP discounts. For Admin it returns all, otherwise it returns the ones belonging to the current merchant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listDefaultVipDiscounts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listDefaultVipDiscounts$Response(params: ListDefaultVipDiscounts$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelDefaultVipDiscountResponseModel>> {
    const obs = listDefaultVipDiscounts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Listing default VIP discounts.
   *
   * Lists available default VIP discounts. For Admin it returns all, otherwise it returns the ones belonging to the current merchant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listDefaultVipDiscounts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listDefaultVipDiscounts(params: ListDefaultVipDiscounts$Params, context?: HttpContext): Observable<PagedModelDefaultVipDiscountResponseModel> {
    const resp = this.listDefaultVipDiscounts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelDefaultVipDiscountResponseModel>): PagedModelDefaultVipDiscountResponseModel => r.body)
    );
  }

  /** Path part for operation `createDefaultVipDiscounts()` */
  static readonly CreateDefaultVipDiscountsPath = '/discounts/vip/defaults';

  /**
   * Create a default VIP discount.
   *
   * Creates a new default VIP discount template. Requires EASYLOT_ADMIN or PRODUCT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDefaultVipDiscounts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDefaultVipDiscounts$Response(params: CreateDefaultVipDiscounts$Params, context?: HttpContext): Observable<StrictHttpResponse<DefaultVipDiscountResponseModel>> {
    const obs = createDefaultVipDiscounts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a default VIP discount.
   *
   * Creates a new default VIP discount template. Requires EASYLOT_ADMIN or PRODUCT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDefaultVipDiscounts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDefaultVipDiscounts(params: CreateDefaultVipDiscounts$Params, context?: HttpContext): Observable<DefaultVipDiscountResponseModel> {
    const resp = this.createDefaultVipDiscounts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DefaultVipDiscountResponseModel>): DefaultVipDiscountResponseModel => r.body)
    );
  }

  /** Path part for operation `triggerDefaultVipDiscount()` */
  static readonly TriggerDefaultVipDiscountPath = '/discounts/vip/defaults/{defaultVipDiscountId}/trigger';

  /**
   * Trigger a default VIP discount.
   *
   * Creates the missing VIP discounts
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `triggerDefaultVipDiscount()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerDefaultVipDiscount$Response(params: TriggerDefaultVipDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VipDiscountDto>>> {
    const obs = triggerDefaultVipDiscount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Trigger a default VIP discount.
   *
   * Creates the missing VIP discounts
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `triggerDefaultVipDiscount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerDefaultVipDiscount(params: TriggerDefaultVipDiscount$Params, context?: HttpContext): Observable<Array<VipDiscountDto>> {
    const resp = this.triggerDefaultVipDiscount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<VipDiscountDto>>): Array<VipDiscountDto> => r.body)
    );
  }

  /** Path part for operation `triggerDefaultVipDiscounts()` */
  static readonly TriggerDefaultVipDiscountsPath = '/discounts/vip/defaults/trigger';

  /**
   * Triggers all default VIP discounts.
   *
   * Creates the missing VIP discounts.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `triggerDefaultVipDiscounts()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerDefaultVipDiscounts$Response(params?: TriggerDefaultVipDiscounts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VipDiscountDto>>> {
    const obs = triggerDefaultVipDiscounts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Triggers all default VIP discounts.
   *
   * Creates the missing VIP discounts.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `triggerDefaultVipDiscounts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerDefaultVipDiscounts(params?: TriggerDefaultVipDiscounts$Params, context?: HttpContext): Observable<Array<VipDiscountDto>> {
    const resp = this.triggerDefaultVipDiscounts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<VipDiscountDto>>): Array<VipDiscountDto> => r.body)
    );
  }

  /** Path part for operation `getReceivedVipDiscountsByDrinkType()` */
  static readonly GetReceivedVipDiscountsByDrinkTypePath = '/discounts/vip/received-by-type';

  /**
   * Gets received VIP discount list.
   *
   * Finds and returns the received VIP discounts.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReceivedVipDiscountsByDrinkType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReceivedVipDiscountsByDrinkType$Response(params?: GetReceivedVipDiscountsByDrinkType$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VipDiscountListByTypeResponse>>> {
    const obs = getReceivedVipDiscountsByDrinkType(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets received VIP discount list.
   *
   * Finds and returns the received VIP discounts.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReceivedVipDiscountsByDrinkType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReceivedVipDiscountsByDrinkType(params?: GetReceivedVipDiscountsByDrinkType$Params, context?: HttpContext): Observable<Array<VipDiscountListByTypeResponse>> {
    const resp = this.getReceivedVipDiscountsByDrinkType$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<VipDiscountListByTypeResponse>>): Array<VipDiscountListByTypeResponse> => r.body)
    );
  }

  /** Path part for operation `getReceivedVipDiscountsByCompany()` */
  static readonly GetReceivedVipDiscountsByCompanyPath = '/discounts/vip/received-by-company';

  /**
   * Gets received VIP discount list.
   *
   * Finds and returns the received VIP discounts.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReceivedVipDiscountsByCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReceivedVipDiscountsByCompany$Response(params?: GetReceivedVipDiscountsByCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VipDiscountListByCompanyResponse>>> {
    const obs = getReceivedVipDiscountsByCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets received VIP discount list.
   *
   * Finds and returns the received VIP discounts.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReceivedVipDiscountsByCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReceivedVipDiscountsByCompany(params?: GetReceivedVipDiscountsByCompany$Params, context?: HttpContext): Observable<Array<VipDiscountListByCompanyResponse>> {
    const resp = this.getReceivedVipDiscountsByCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<VipDiscountListByCompanyResponse>>): Array<VipDiscountListByCompanyResponse> => r.body)
    );
  }

  /** Path part for operation `getGivenVipDiscountLists()` */
  static readonly GetGivenVipDiscountListsPath = '/discounts/vip/given';

  /**
   * Gets given discount list.
   *
   * Finds and returns the given VIP discounts.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGivenVipDiscountLists()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGivenVipDiscountLists$Response(params?: GetGivenVipDiscountLists$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VipDiscountListByCompanyResponse>>> {
    const obs = getGivenVipDiscountLists(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets given discount list.
   *
   * Finds and returns the given VIP discounts.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGivenVipDiscountLists$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGivenVipDiscountLists(params?: GetGivenVipDiscountLists$Params, context?: HttpContext): Observable<Array<VipDiscountListByCompanyResponse>> {
    const resp = this.getGivenVipDiscountLists$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<VipDiscountListByCompanyResponse>>): Array<VipDiscountListByCompanyResponse> => r.body)
    );
  }

  /** Path part for operation `searchGivenVipDiscounts()` */
  static readonly SearchGivenVipDiscountsPath = '/discounts/vip/given/search';

  /**
   * Searches given VIP discounts (paged, filterable).
   *
   * Returns the current merchant's given VIP discounts as a flat page, optionally filtered by company (toMerchant) and by product name (packaging unit label, LIKE). Filters work independently and combined.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchGivenVipDiscounts()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchGivenVipDiscounts$Response(params: SearchGivenVipDiscounts$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelVipDiscountDto>> {
    const obs = searchGivenVipDiscounts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Searches given VIP discounts (paged, filterable).
   *
   * Returns the current merchant's given VIP discounts as a flat page, optionally filtered by company (toMerchant) and by product name (packaging unit label, LIKE). Filters work independently and combined.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchGivenVipDiscounts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchGivenVipDiscounts(params: SearchGivenVipDiscounts$Params, context?: HttpContext): Observable<PagedModelVipDiscountDto> {
    const resp = this.searchGivenVipDiscounts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelVipDiscountDto>): PagedModelVipDiscountDto => r.body)
    );
  }

  /** Path part for operation `getGivenVipDiscountCompanies()` */
  static readonly GetGivenVipDiscountCompaniesPath = '/discounts/vip/given/companies';

  /**
   * Lists companies for the given VIP discount filter.
   *
   * Returns the companies (toMerchants) the current merchant grants VIP discounts to, for the filter dropdown.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGivenVipDiscountCompanies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGivenVipDiscountCompanies$Response(params?: GetGivenVipDiscountCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VipDiscountCompanyDto>>> {
    const obs = getGivenVipDiscountCompanies(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Lists companies for the given VIP discount filter.
   *
   * Returns the companies (toMerchants) the current merchant grants VIP discounts to, for the filter dropdown.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGivenVipDiscountCompanies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGivenVipDiscountCompanies(params?: GetGivenVipDiscountCompanies$Params, context?: HttpContext): Observable<Array<VipDiscountCompanyDto>> {
    const resp = this.getGivenVipDiscountCompanies$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<VipDiscountCompanyDto>>): Array<VipDiscountCompanyDto> => r.body)
    );
  }

}
